module.exports = __webpack_public_path__ + "static/media/1-Estimate-small.9475fb6e.png";